<div class="configuration-container">
	<app-tabs
		[tabHeaders]="tabHeaders"
		[(selectedTab)]="selectedTab"
		type="pill"
		size="medium"
		[fitContent]="true">
	</app-tabs>

	<div class="tab-content">
		@switch (activeTabId) {
			@case ('products') {
				<app-products></app-products>
			}
			@case ('platforms') {
				<app-platforms></app-platforms>
			}
			@case ('discounts') {
				<app-discounts></app-discounts>
			}
		}
	</div>
</div>
